// Chakra database — derived from the dominant Pancha element (Vedic correspondence
// maps the first five chakras onto the five elements).
// `intro` = plain-language description used on the Sacred Report chakra card.
// `petalNote` = one-line reminder of how many petals the traditional lotus has.

export const CHAKRA = {
  earth: {
    name: "Muladhara",
    english: "Root Chakra",
    color: "Red",
    location: "Base of spine",
    mantra: "LAM",
    governs: "Grounding, safety, feeling stable",
    intro: "This is your Earth-element chakra, sitting right at the base of your spine. It's in charge of grounding, safety, and feeling stable.",
    petalNote: "In yogic tradition, every chakra is drawn as a lotus with a certain number of petals — yours has 4.",
    bijaNote: "LAM is the sound that switches on your Root Chakra.",
  },
  water: {
    name: "Svadhisthana",
    english: "Sacral Chakra",
    color: "Orange",
    location: "Below the navel",
    mantra: "VAM",
    governs: "Feelings, creativity, closeness",
    intro: "This is your Water-element chakra, sitting just below your belly button. It's in charge of comfort, feelings, and creativity.",
    petalNote: "In yogic tradition, every chakra is drawn as a lotus — yours has 6 petals.",
    bijaNote: "VAM is the sound that switches on your Sacral Chakra.",
  },
  fire: {
    name: "Manipura",
    english: "Solar Plexus Chakra",
    color: "Yellow",
    location: "Above the navel",
    mantra: "RAM",
    governs: "Confidence, willpower, personal fire",
    intro: "This is your Fire-element chakra, sitting just above your belly button. It's in charge of confidence, willpower, and getting things done.",
    petalNote: "In yogic tradition, every chakra is drawn as a lotus — yours has 10 petals.",
    bijaNote: "RAM is the sound that switches on your Solar Plexus Chakra.",
  },
  air: {
    name: "Anahata",
    english: "Heart Chakra",
    color: "Green",
    location: "Center of chest",
    mantra: "YAM",
    governs: "Love, kindness, connection",
    intro: "This is your Air-element chakra, sitting in the centre of your chest. It's in charge of love, kindness, and how you connect with people.",
    petalNote: "In yogic tradition, every chakra is drawn as a lotus — yours has 12 petals.",
    bijaNote: "YAM is the sound that switches on your Heart Chakra.",
  },
  ether: {
    name: "Vishuddha",
    english: "Throat Chakra",
    color: "Blue",
    location: "Throat",
    mantra: "HAM",
    governs: "Truth, expression, speaking clearly",
    intro: "This is your Ether-element chakra, sitting at your throat. It's in charge of speaking your truth, expressing yourself, and being heard.",
    petalNote: "In yogic tradition, every chakra is drawn as a lotus — yours has 16 petals.",
    bijaNote: "HAM is the sound that switches on your Throat Chakra.",
  },
};

export function chakraFor(element) {
  return CHAKRA[element] || null;
}
